import type { Product } from '../../../data/product';
import { daysOverdue } from '../../../hooks/products';
import { Tooltip } from '../../popover/tooltip';
import { StatusCell } from '../../status/status-cell';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const DaysOverdue: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Days Overdue',
  minWidth: 80,
  accessorFn: (product) => {
    const overdue = daysOverdue(product);

    return overdue > 0 ? `+${overdue.toFixed(0)}` : overdue.toFixed(0);
  },
  sortingFn: (a, b) => daysOverdue(a) - daysOverdue(b),
  cell: ({ item: product, value }) => {
    const overdue = daysOverdue(product);
    if (overdue >= 14) {
      const days = overdue.toFixed(0);

      return (
        <Tooltip
          content={`Selling much slower than usual — ${days} days past this product's average sale cadence. Check stock and pricing.`}
        >
          <StatusCell variant="danger">{value}</StatusCell>
        </Tooltip>
      );
    }

    if (overdue >= 7) {
      const days = overdue.toFixed(0);

      return (
        <Tooltip
          content={`Selling slower than usual — ${days} days past this product's average sale cadence.`}
        >
          <StatusCell variant="attention">{value}</StatusCell>
        </Tooltip>
      );
    }

    return <span>{value}</span>;
  },
});
